import React from 'react'
import DealingsNavigator from "../../components/DealingsNavigator";
import getObjectValue from "libs/getObjectValue";
import {FieldArray} from "formik";
import OrderObjectDividedList from "./OrderObjectDividedList";


function OrderObjectDivided(
    {
        id,
        formikProps,
        realizationType
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const curIndex = gVal("orderDealing", false, -1);

    return (<FieldArray
        name={gId("divided")}
        render={() => (<>
            <DealingsNavigator
                formikProps={formikProps}
                id="orderDealing"
                items={gVal("divided", true, [])}
            />
            {curIndex > -1 &&
                <OrderObjectDividedList
                    formikProps={formikProps}
                    id={gId("divided." + curIndex)}
                    realizationType={realizationType}
                    index={curIndex}
                />
            }

        </>)}
    />)
}

OrderObjectDivided.propTypes = {};

export default OrderObjectDivided;
